import { axiosInstance } from "@/api/axiosInstance";
import { assetsService } from "./assets";

export const companyService = {
  getCompanies: async (page = 0, size = 200) => {
    try {
      const response = await axiosInstance.get(`/companies`, {
        params: { page, size },
      });
      console.log(response.data)
      return response.data || [];
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  getCompany: async (companyId) => {
    try {
      const response = await axiosInstance.get(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  getCompaniesPaginated: async (page = 0, size = 20) => {
    try {
      const response = await axiosInstance.get(`/companies/all-companies-pg`, {
        params: { page, size },
      });
      return response.data || { result: [], totalPages: 1 };
    } catch (error) {
      console.error("Error fetching companies:", error.message);
      throw error;
    }
  },
  updateCompany: async (company) => {
    try {
      const response = await axiosInstance.put(
        `/companies/${company.id}`,
        company
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  /**
   * Saves the company's Meta Pixel. Either field may be left out to keep the stored value; the access
   * token is write-only - it is stored encrypted and the response only says whether one is set.
   */
  saveMetaPixel: async (companyId, { metaPixelId, metaAccessToken }) => {
    const { data } = await axiosInstance.put(`/companies/${companyId}/meta-pixel`, {
      metaPixelId,
      metaAccessToken,
    });
    return data;
  },
  removeMetaPixel: async (companyId) => {
    const { data } = await axiosInstance.delete(`/companies/${companyId}/meta-pixel`);
    return data;
  },
  /** Sends a test event through Meta's Conversions API and returns what Meta made of it. */
  testMetaPixel: async (companyId, testEventCode) => {
    const { data } = await axiosInstance.post(`/companies/${companyId}/meta-pixel/test`, {
      testEventCode,
    });
    return data;
  },
  deleteCompany: async (companyId) => {
    try {
      const response = await axiosInstance.delete(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  createCompany: async ({
    companyName,
    industry,
    address,
    website,
    logo,
    numberOfEmployees,
    firstname,
    lastname,
    email,
    phoneNumber,
    password,
  }) => {
    try {
      const response = await axiosInstance.post(`/companies`, {
        companyName,
        industry,
        address,
        website,
        numberOfEmployees,
        firstname,
        lastname,
        email,
        phoneNumber,
        password,
      });
      if (logo) {
        await assetsService.uploadAsset({
          file: logo,
          contentType: "IMAGE",
          entityType: "COMPANY",
          entityId: response.data.id,
          description: "COMPANY_LOGO",
        });
      }
      return response.data;
    } catch (error) {
      console.error("Error creating company:", error.message);
      throw error;
    }
  },

  // ========== COMPANY MEMBERS / USERS ==========

  getCompanyMembersPaginated: async (companyId, page = 0, size = 20, search = "") => {
    try {
      const response = await axiosInstance.get(`/companies/all-company-members-pg/${companyId}`, {
        params: { page, size, search },
      });
      return response.data || { result: [], totalPages: 1, totalItems: 0 };
    } catch (error) {
      console.error("Error fetching company members:", error.message);
      throw error;
    }
  },

  getCompanyMemberById: async (userId) => {
    try {
      const response = await axiosInstance.get(`/companies/member-by-id/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching company member by ID:", error.message);
      throw error;
    }
  },

  addCompanyMember: async (companyId, memberData) => {
    try {
      const response = await axiosInstance.post(`/companies/company-member/${companyId}`, memberData);
      return response.data;
    } catch (error) {
      console.error("Error adding company member:", error.message);
      throw error;
    }
  },

  updateCompanyMember: async (userId, memberData) => {
    try {
      const response = await axiosInstance.put(`/companies/company-member/${userId}`, memberData);
      return response.data;
    } catch (error) {
      console.error("Error updating company member:", error.message);
      throw error;
    }
  },

  deleteCompanyMember: async (userId) => {
    try {
      const response = await axiosInstance.delete(`/companies/company-member/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting company member:", error.message);
      throw error;
    }
  },
};
